import { parseNumber } from './numberConversions'

export const getYearFromDate = (date) => {
  if (!date) return date
  const year = new Date(`${date}`).getFullYear()
  if (isNaN(year) || date.length < 4) {
    return date
  }
  return year
}

export const getLongDateFromDate = (date) => {
  const dateObject = new Date(date)
  const longDate =
    dateObject.toLocaleString('en', { day: 'numeric' }) + ' ' +
    dateObject.toLocaleString('en', { month: 'long' }) + ' ' +
    dateObject.toLocaleString('en', { year: 'numeric' })
  return longDate
}

export const getAgeAtDate = (date, currentAge) => {
  const year = new Date(`${date}`).getFullYear()
  if (isNaN(year) || date.length < 4) {
    throw Error('An Invalid date was passed to the getAgeAtDate function call')
  }
  return parseNumber(year) - currentYear() + parseNumber(currentAge)
}

export const getYearFromAge = (age, currentAge) => {
  return parseNumber(age) + currentYear() - parseNumber(currentAge)
}

export const getAgeFromYear = (year, currentAge) => {
  return parseNumber(year) - currentYear() + parseNumber(currentAge)
}

export const getTimestamp = (_date, options = {}) => {
  if (!_date) {
    return null
  }
  const date = new Date(_date)
  const { dateOnly } = options

  const year = date.getFullYear()
  const month = appendZeroIfLessThanTen(date.getMonth() + 1)
  const day = appendZeroIfLessThanTen(date.getDate())

  const hours = appendZeroIfLessThanTen(date.getHours())
  const minutes = appendZeroIfLessThanTen(date.getMinutes())

  return `${year}/${month}/${day} ${dateOnly ? '' : `${hours}:${minutes}`}`
}

const appendZeroIfLessThanTen = (value) =>
  value < 10 ? `0${value}` : value

export const currentYear = () =>
  new Date().getFullYear()
